import { render, staticRenderFns } from "./GeneralSettingsPage.vue?vue&type=template&id=49e9e9e4&scoped=true"
import script from "./GeneralSettingsPage.vue?vue&type=script&lang=js"
export * from "./GeneralSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./GeneralSettingsPage.vue?vue&type=style&index=0&id=49e9e9e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9e9e4",
  null
  
)

export default component.exports